import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden pb-[64px]" style={{ overflow: 'auto' }}>
            <div className="w-full text-[32px] font-bold pt-[32px] text-center text-[#6E604C] px-[16px]">
                重磅官宣！「2025香港國際人才節」即將盛大啟幕！誠邀各界參與！
            </div>
            <div className="w-full h-full flex-col flex max-w-[800px] pt-[32px] gap-[16px] pb-[64px] px-[16px]">
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    「2025香港國際人才節」將於10月20日至21日在香港盛大舉行。首屆人才節以「凝才聚智，協同發展，領航未來」為主題，包涵香港國際人才高峰論壇、香港國際人才職業博覽會、iCANX香港科學峰會、U8世界創新峰會等系列活動。歡迎海內外企業機構與優秀人才踴躍參與，攜手共建香港國際人才集聚高地，拓展無限發展機遇！
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e1.png' className="w-full" style={{}} />


                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    2025香港國際人才節
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    為深入貫徹二十屆三中全會《決定》精神，「發揮香港‘一國兩制’制度優勢，鞏固提升香港國際金融、航運、貿易中心地位，支持香港打造國際高端人才集聚高地」的戰略部署，積極落實第十四屆全國人民代表大會第三次會議政府工作報告關於「推進高水平人才高地和吸引集聚人才平臺建設」的具體要求，「2025香港國際人才節」將於10月20日至21日在香港灣仔會議展覽中心舉辦。
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    首屆香港國際人才節以“凝才聚智，協同發展，領航未來”為主題，廣邀中央政府有關領導、香港特區政府主要官員、內地相關政府和國際組織主要官員、政商學研各界知名人士、海內外高端人才齊聚一堂，搭建國際高端人才交流、對接、合作平臺，為香港、灣區和國家發展貢獻力量！
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    大會融匯第五屆香港國際人才高峰論壇、香港國際人才職業博覽會（第四季）、iCANX Hong Kong Summit 2025、U8世界創新峰會四大旗艦活動，形式豐富多樣，包括典禮儀式、主題演講、圓桌討論、科創大賽、展覽展示、科學之夜、私享晚宴等；內容精彩紛呈，思想跨越山海，機會無界流動，創新在此裂變。活動將吸引上百家海內外知名媒體持續報導， 預計將在海內外形成廣泛的影響力。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    四大旗艦活動
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e2.png' className="w-full" style={{}} />


                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    百年變局與科技革命交織激蕩之際，人才已成為重構世界格局的「第一資源」，2025香港國際人才節集合四大旗艦活動，匯聚全球精英，共鑄人才盛會！
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    第五屆香港國際人才高峰論壇
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    香港國際人才高峰論壇是一項旨在彙聚全球精英、探討人才發展趨勢與策略的國際性高端會議。由香港優才及專才協會聯同港澳特區政府及多個內地城市相關部門共同舉辦，彙聚海內外的官員、專家、學者、企業家和各領域人才。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    2025香港國際人才職業博覽會第四季
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    香港國際人才職業博覽會由香港特區政府勞工及福利局、人才辦為官方策略夥伴，香港優才及專才協會、香港管理專業協會、香港經濟日報聯合主辦，是一場貫穿全年的職業盛會，聚焦香港「八大中心」定位的多個相關行業，整合政商學界優質資源，搭建優秀人才與頂尖企業的對接平臺。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    iCANX香港科學峰會
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    iCANX Association（國際科學家聯合會）是一個註冊在瑞士、由全世界對科學、技術和教育感興趣的個人組成的不分性別、種族、國籍的非營利、獨立公正的國際組織，致力於為頂尖科學家、研究人員、創新者和民間社會代表提供一個中立合作空間，展示改變世界的力量。iCANX香港科學峰會將彙聚來自各領域全球頂尖人物，共同分享他們在創新、科學、技術、投資、管理及進化 （ISTIME）方面的最新前沿成果及深刻見解。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    U8世界創新峰會
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    由來自牛津大學、劍橋大學、哈佛大學、麻省理工學院、斯坦福大學、加州理工學院、清華大學以及北京大學等世界頂尖8所大學的中國學子於2020年攜手發起。峰會邀請擁有全球影響力/業界權威的大咖嘉賓，通過主題演講、圓桌論壇、對話等方式,就多個前瞻性熱點話題進行深入對話探討，碰撞創新火花與力量。

                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    活動亮點
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    一、規格高
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    廣邀中央政府、香港特區政府和內地省市政府相關主要官員，以及主要國際組織代表等海內外政商學界知名人士、高端人才齊聚一堂，為香港、灣區和國家美好未來建言獻策。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    二、規模大
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    活動於香港世界性的盛事舉辦地灣仔會展舉辦，場地總面積超過7,000平方米，現場預計超過8,000人次參與；同時通過各線上主流平台實時直播，參與人數預計近百萬。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    三、內容豐富
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    活動由主論壇、分論壇、展覽展示、評獎評選、換屆典禮、私享晚宴和科學之夜等組成，圍繞人才各類主題進行重磅主題演講、圓桌討論、人才招聘、展覽展示、項目洽談等，形式豐富多樣，內容精彩紛呈。
                </div>
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    四、影響力廣
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    新華社、人民網、CCTV、中新社、中通社，中聯社，聯合國教科文組織，香港政府新聞網、香港電台，大公文匯、紫荊、鳳凰衛視，香港商報，澳門日報，聯合早報，歐洲時報，英文虎報等過百家海內外重磅媒體對峰會持續報導，總瀏覽人次預計超過8,000萬，在海內外形成廣泛的影響力。
                </div>

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    成就積累
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    香港國際人才節系列旗艦活動，經過多年專業運作已經形成了眾多亮點，吸引了海內外的廣泛關注與參與。以下是往屆峰會的主要成就和亮點：
                    o	參與機構：來自25個海內外政府部門和機構的代表參加，展示了全球對於人才交流的重視；
                    o	演講嘉賓：累積邀請了超過280位專業領域的演講嘉賓，分享他們在人才發展、學術研究、創新創業等方面的見解與經驗；
                    o	展商參與：活動吸引了逾180家展商參展，展示最新的技術與服務，提供精選崗位招攬優秀人才；
                    o	現場觀眾：合計超過18,000名現場觀眾親臨現場，共同探索人才發展的未來；
                    o	合作夥伴：有60多家合作夥伴的支持，使活動的舉辦更加成功；
                    o	線上觀眾：活動線上直播吸引了超過150萬的線上觀眾，進一步擴大了影響力；
                    o	媒體報道：240多家海內外重點媒體參與報道，總瀏覽量達到9,000萬次，充分展現了峰會的廣泛影響。
                </div>

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    價值收穫
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    通過參加香港國際人才節系列活動，各地政府機構及合作夥伴能夠在全球人才競爭中佔據優勢，並產生多方面的收穫和效益，具體包括：<br /><br />
                    o	政策交流：與其他國家和地區的政府機構分享和交流人才政策，促進政策創新；<br />
                    o	網絡建設：建立與海內外政府、機構和業界的聯繫，拓展合作網絡；<br />
                    o	信息獲取：獲取全球人才市場的最新動態和趨勢，為決策提供依據；<br />
                    o	政策宣傳：通過對本地人才及產業政策宣講，讓更多國際化人才瞭解本地發展機遇；<br />
                    o	人才引進：吸引海外優秀人才回國或來本地區工作，推動本地科技創新和產業升級；<br />
                    o	經驗分享：借鑒其他地區在人才培養和引進方面的成功經驗，優化本地政策；<br />
                    o	項目合作：促進與國際、國內和灣區機構、企業的合作項目，推動經濟發展；<br />
                    o	品牌提升：提升本地區在國際人才市場的知名度和吸引力，增強地區形象；<br />
                    o	投資促進：吸引外資，促進經濟增長，提升區域競爭力；<br />
                    o	研究合作：推動與國際高校和研究機構的合作，促進學術交流與研究；<br />
                    o	多元交流：促進不同文化背景下的交流與理解，提升社會包容性；<br />
                    o	政策評估：通過與國際同行的對比，評估和改進本地人才政策的有效性。
                </div>

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    活動詳情
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    日期：2025年10月20日、21日（星期一、二）<br />
                    分論壇：10月20日 10:30 ~ 18:15<br />
                    開幕式系列活動：10月20日 18:30 ~ 20:00<br />
                    主論壇及博覽會：10月21日 09:30 ~ 18:30<br />
                    地點：香港灣仔博覽道一號  香港會議展覽中心
                </div>

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    活動形式
                </div>

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    A.主題演講</div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    邀請重量級嘉賓，就人才相關主題發表重磅演講，高屋建瓴、開篇名義。
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e3.jpg' className="w-full" style={{}} />

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    B.圓桌論壇
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    邀請政商學界知名人士及專家，就論壇相關主題展開討論，研討問題及策略。
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e4.jpg' className="w-full" style={{}} />
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    C.科創大廈
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    集合全球優秀大學生科創項目，現場展示，路演，評選及頒獎，與優秀創業者面對面。
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e5.jpg' className="w-full" style={{}} />
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    D.職業博覽</div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    現場搭建展位，可進行企業的形象展示、人才政策宣傳、高端人才招聘和產品服務的展覽。
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e6.jpg' className="w-full" style={{}} />

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    E.科學之夜</div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    國際政商學界名流、青年科學家、行業高端人才歡聚一堂，共饗表演互動，共享盛會雅聚。
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e7.jpg' className="w-full" style={{}} />
                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    F.私享晚宴
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    品美味佳餚，賞維港之夜，在獨特的氛圍中與海內外專家學者交流暢談。
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e8.jpg' className="w-full" style={{}} />

                <div className="w-full text-[24px] font-bold p-[16px] text-center text-[#6E604C]">
                    報名參與
                </div>
                <div className="w-full text-[16px] text-[#6E604C] text-justify">
                    為了更好地踐行人才節宗旨，我們將秉持『開放辦會、共創共用』的理念，歡迎香港、內地和海外政府部門、組織機構和公司企業等機構和海內外人才積極參與，共同努力把2025香港國際人才節辦成政、商、學界和專業界合作交流、融合發展的人才盛會！
                </div>
                <img src='https://t-gather.s3.ap-southeast-1.amazonaws.com/home/e9.png' className="w-full" style={{}} />
                <br />
                <br />
                <br />


            </div>
        </div >
    )
}